module.exports = __webpack_public_path__ + "img/device-mb.c3e125f7.webp";